export const getMTODeliveryDate = (createdAt?: string) => {
  const baseDate = createdAt ? new Date(createdAt) : new Date()
  const deliveryDate = new Date(baseDate)
  deliveryDate.setDate(baseDate.getDate() + 21)

  return deliveryDate.toLocaleDateString('en-GB', {
    month: 'long',
    day: 'numeric'
  })
}
